import { useId, useLayoutEffect, useRef, useState } from 'react';
import { PlacesType } from 'react-tooltip';
import { Tooltip } from 'shared/ui/icon-tooltip/icon-tooltip';
import cls from './truncated-text.module.scss';

interface TruncatedTextProps {
  text: string;
  className?: string;
  place?: PlacesType;
  maxWidth?: number | string;
}

export const TruncatedText: React.FC<TruncatedTextProps> = props => {
  const { text, className, place, maxWidth = 'min(90vw, 480px)' } = props;
  const id = useId();
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) return;
    setIsTruncated(el.scrollWidth > el.clientWidth);
  }, [text]);

  return (
    <>
      <span
        ref={textRef}
        className={`${cls.truncatedText} ${className ?? ''}`}
        data-tooltip-id={isTruncated ? id : undefined}
      >
        {text}
      </span>
      {isTruncated && (
        <Tooltip id={id} place={place} maxWidth={maxWidth}>
          <span className={cls.tooltipContent}>{text}</span>
        </Tooltip>
      )}
    </>
  );
};
